var map = {
	"./ADELAIDE.svg": "odBq",
	"./BRISBANE-LIONS.svg": "GGVM",
	"./CARLTON.svg": "b8Jz",
	"./COLLINGWOOD.svg": "ntsG",
	"./ESSENDON.svg": "FrYn",
	"./FREMANTLE.svg": "q+wX",
	"./GEELONG.svg": "PKrk",
	"./GOLD-COAST.svg": "YWLr",
	"./GWS-GIANTS.svg": "ZsFg",
	"./HAWTHORN.svg": "tqzf",
	"./MELBOURNE.svg": "ji0/",
	"./NORTH-MELBOURNE.svg": "j9i6",
	"./PORT-ADELAIDE.svg": "5Puw",
	"./RICHMOND.svg": "lIbZ",
	"./ST-KILDA.svg": "Eu2Y",
	"./SYDNEY.svg": "yhIV",
	"./WEST-COAST.svg": "lIhJ",
	"./WESTERN-BULLDOGS.svg": "OVvc",
	"./header.svg": "v8Uc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KZtR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.svg$
// module id = KZtR
// module chunks = 0